import React from "react";
import { Box, Card, CardHeader, Switch, Divider } from "@mui/material";
import { updateNotificationSettings } from "../../api/notification";
import { useModeStore } from "../../stores/store-settings";

const NotificationsSettings = () => {
  const { notificationEnabled, setNotification, emailNotificationEnabled, setEmailNotification } = useModeStore();

  return (
    <>
    <Card>
      <CardHeader
        subheader="Verwalten Sie die Benachrichtigungen"
        title={
          <Box display="flex" alignItems="center">
            Benachrichtigungen
            <Switch
              color="success"
              checked={notificationEnabled}
              onChange={() => {
                setNotification(!notificationEnabled); // update the new value in the global state
                updateNotificationSettings({
									is_notification_enabled: !notificationEnabled,
								});
              }}
            />
          </Box>
        }
      />
      <Divider />
      {/* Add your content here */}
    </Card>

      <Card style={{ marginTop: "24px" }}>
        <CardHeader
          subheader="Entscheiden Sie, ob Sie bei einer Benachrichtigung eine E-Mail erhalten wollen"
          title={
            <Box display="flex" alignItems="center">
              Benachrichtigungs E-Mails erhalten
              <Switch
                color="success"
                checked={emailNotificationEnabled}
                onChange={() => {
                  setEmailNotification(!emailNotificationEnabled); // update the new value in the global state
                  updateNotificationSettings({
                    is_email_notification_enabled: !emailNotificationEnabled,
                  });
                }}
              />
            </Box>
          }
        />
        <Divider />
      </Card>
    </>
  );
};

export default NotificationsSettings;
